import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import css from '../css/Addcase.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import { apiRequest } from '../store/allApi'

const Redeem = ({ walletUpdate }) => {
  const history = useHistory()

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const [amount, setamount] = useState()
  const [userAllData, setUserAllData] = useState()
  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`me`, "GET", null, headers)
      if (res) {
        setUserAllData(res.data)
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
      }

    }
    finally {
    }
  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    role()
  }, [])

  const deposit = async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }


      try {
        const res = await apiRequest(`referral/to/wallet`, "POST", { amount }, headers)
        if (res) {
          if (res.data.msg === 'Invalid Amount') {
            Swal.fire({
              title: "You don't have sufficient amount",
              icon: 'warning',
              confirmButtonText: 'OK'
            })
          } else {
            Swal.fire({
              title: 'success',
              icon: 'success',
              confirmButtonText: 'OK'
            })
          }
        }
      } catch (e) {
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          history.push('/login')
        }
      }
      finally {
      }
    } else {
      let msg = 'Enter Amount'
      if (!amount) {
        msg = 'Enter Amount'
      } else if (95 <= amount <= 100000) {
        msg = 'Amount should be more than 95.'
      }
      Swal.fire({
        title: msg,
        icon: 'Error',
        confirmButtonText: 'OK'
      })
    }
  }

  return (
    <>
      <Header user={userAllData} />
      <div
        className='leftContainer mb_space'
        style={{ minHeight: '100vh', height: '100%' }}
      >
        <div className="redeem-card-modern">

  <div className="redeem-header">
    <div>
      <h2>Redeem Referral Balance</h2>
      <p>
        Convert your referral earnings directly into your wallet.
      </p>
    </div>

    <div className="redeem-badge">
      <span>💰 Referral Reward</span>
    </div>
  </div>

  <div className="redeem-info-box">
    <div className="info-item">
      <span>Min Amount</span>
      <strong>₹100</strong>
    </div>

    <div className="info-divider"></div>

    <div className="info-item">
      <span>Max Amount</span>
      <strong>₹10,000</strong>
    </div>
  </div>

  <div className="tds-alert">
    <span>ℹ️</span>
    TDS (0%) will be deducted after annual referral earnings exceed ₹15,000.
  </div>

  <div className="amount-input-wrap">
    <label>Enter Redeem Amount</label>

    <div className="amount-input-box">
      <span className="currency">₹</span>

      <input
        type="number"
        value={amount}
        placeholder="Enter Amount"
        onChange={(e) => setamount(parseInt(e.target.value) || '')}
      />
    </div>

    <div className="withdraw-note">
      Minimum redeem amount ₹95
    </div>
  </div>

  <button
    className="redeem-btn-modern"
    onClick={() => deposit()}
  >
    Redeem Now
  </button>

</div>
      </div>
    </>
  )
}
export default Redeem
